import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import MedicationIcon from "@mui/icons-material/Medication";
import MemoryIcon from "@mui/icons-material/Memory";
import MobileShell from "./MobileShell";
import { clearMobileSession } from "./session";

export default function MobileHome() {
  const navigate = useNavigate();

  const logout = () => {
    clearMobileSession();
    navigate("/mobile/login", { replace: true });
  };

  const menus = [
    {
      title: "วัคซีน",
      description: "บันทึกการฉีดวัคซีน",
      icon: <VaccinesIcon sx={{ fontSize: 34 }} />,
      path: "/mobile/service/vaccine",
      color: "#e85f24",
    },
    {
      title: "ปรสิต",
      description: "บันทึกการป้องกันปรสิต",
      icon: <MedicationIcon sx={{ fontSize: 34 }} />,
      path: "/mobile/service/parasite",
      color: "#0f766e",
    },
    {
      title: "Microchip",
      description: "บันทึกการฝังไมโครชิป",
      icon: <MemoryIcon sx={{ fontSize: 34 }} />,
      path: "/mobile/service/microchip",
      color: "#2563eb",
    },
  ];

  return (
    <MobileShell title="บริการ" onLogout={logout}>
      <Box sx={{ px: 2, py: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, color: "#172033" }}>
          เลือกบริการ
        </Typography>
        <Typography sx={{ mt: 0.5, color: "#667085", fontSize: 14 }}>
          เมนูสำหรับใช้งานบนมือถือ
        </Typography>

        <Box
          sx={{
            display: "grid",
            gap: 2,
            mt: 3,
          }}
        >
          {menus.map((menu) => (
            <Button
              key={menu.path}
              onClick={() => navigate(menu.path)}
              sx={{
                minHeight: 190,
                p: 3,
                borderRadius: 2,
                bgcolor: "#fff",
                color: "#172033",
                border: "1px solid #eceff3",
                boxShadow: "0 8px 24px rgba(16, 24, 40, 0.08)",
                textTransform: "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                "&:hover": { bgcolor: "#fafafa" },
              }}
            >
              <Box
                sx={{
                  width: 92,
                  height: 92,
                  borderRadius: 2,
                  display: "grid",
                  placeItems: "center",
                  color: "#fff",
                  bgcolor: menu.color,
                  "& .MuiSvgIcon-root": {
                    fontSize: 58,
                  },
                }}
              >
                {menu.icon}
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ fontWeight: 800, fontSize: 20, lineHeight: 1.2 }}>
                  {menu.title}
                </Typography>
                <Typography sx={{ color: "#667085", fontSize: 13, mt: 0.5 }}>
                  {menu.description}
                </Typography>
              </Box>
            </Button>
          ))}
        </Box>
      </Box>
    </MobileShell>
  );
}
